/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from "prop-types";

class DisplayJson extends Component {


    render() {

        return (
            <>
                <pre
                    className={"font-mono p-2 border rounded text-xs bg-stone-50 overflow-auto customScrollbarSmall h-96"}>
                    {JSON.stringify(this.props.jsonInput, null, '\t')}
                </pre>
            </>
        );
    }
}

DisplayJson.propTypes = {
    jsonInput: PropTypes.any.isRequired
};

export default DisplayJson;